import cx from "classnames";
import parse from "html-react-parser";
import { ButtonHTMLAttributes, FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "reactstrap";

import uuid from "../../utils/uuid";
import Dialog from "../Dialog";
import { FaSpinner } from "react-icons/fa";

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  id?: string;
  icon?: any;
  text?: string;
  confirmText?: string;
  showConfirm?: boolean;
  tooltipText?: string;
  disabled?: boolean;
  buttonClassName?: string;
  buttonText?: string;
}

const Button: FC<IButtonProps> = (props: IButtonProps) => {
  const { t } = useTranslation();
  const {
    id,
    icon,
    text,
    showConfirm = false,
    confirmText = t("İşleminize devam etmek istiyor musunuz?"),
    tooltipText,
    onClick,
    className,
    disabled,
    buttonClassName = "success",
    buttonText = t("Confirm"),
    ...rest
  } = props;

  const [isPending, setPending] = useState<boolean>(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const buttonId = useMemo(() => (id ? id : `button-${uuid.v4()}`), []);

  const _onClick = async (event: any) => {
    if (!onClick) return;

    // Start pending state
    setPending(true);
    try {
      if (showConfirm) {
        const choice = await Dialog({
          content: t(confirmText ?? ""),
          buttonClassName: buttonClassName,
          buttonText: buttonText,
          showOKButton: true,
        });

        if (choice) {
          await onClick(event);
        }
      } else {
        await onClick(event);
      }
    } catch (error) {
      // Optionally handle errors
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      <button
        id={buttonId}
        className={className}
        onClick={_onClick}
        {...rest}
        disabled={disabled || isPending}
      >
        {isPending && <FaSpinner className="me-2 fa-spin" />}
        {icon && !isPending && icon}
        {text && text.length > 0 && parse(text)}
      </button>
      {tooltipText && tooltipText.length > 0 && (
        <Tooltip
          placement={"top"}
          isOpen={tooltipOpen}
          target={buttonId}
          toggle={toggleTooltip}
        >
          {tooltipText}
        </Tooltip>
      )}
    </>
  );
};

export default Button;
